import BaseEcomServices from "./BaseEcomServices";
import BaseServices from "./BaseServices";

const OrderServices = {
    SyncOrder: async (postData) => {
        return await BaseServices.Post("/api/orders/sync-order", postData);
    },
    GetOrdersPage: async (paging) => {
        return await BaseServices.Post("/api/orders/get-orders", paging);
    },
    GetOrderPageCount: async (platform) => {
        return await BaseServices.Get(`/api/orders/get-orders-page-count/${platform}`);
    },
    GetOrderDetail: async (id) => {
        return await BaseServices.Get("/api/orders/orders-detail/" + id);
    },
    VerifyOrder: async (orderId, isDirectPet = false) => {
        return await BaseServices.Get(`/api/orders/verify-order/${orderId}/${isDirectPet}`);
    },
    PrintShippingLabel: async (orderId, shippingCompanyId, shipModel = {}) => {
        return await BaseServices.Post(`/api/orders/print-shipping-label?orderId=${orderId}&shippingCompanyId=${shippingCompanyId}`, shipModel);
    },
    PrintShippingLabelRanus: async (orderId, shippingCompanyId) => {
        return await BaseServices.Post(`/api/orders/print-shipping-label-ranus?orderId=${orderId}&shippingCompanyId=${shippingCompanyId}`);
    },
    SetStatusToReadyToShip: async (orderId) => {
        return await BaseServices.Post(`/api/orders/ready-to-ship/${orderId}`, null);
    },
    GetListOrderAffiliateInfo: async (paging) => {
        return await BaseServices.Post(`/api/orders/get-list-order-affiliate`, paging);
    },
    ChangeOrderStatus: async (orderId, status) => {
        return await BaseServices.Get(`/api/orders/change-order-status?id=${orderId}&status=${status}`);
    },
    ChangeMultiOrderStatus: async (orderIds, status) => {
        return await BaseServices.Post(`/api/orders/change-multi-order-status?status=${status}`, orderIds);
    },
    GetHandleOverToShipper: async (orderId) => {
        return await BaseServices.Get(`/api/orders/get-handleover-to-shipper?orderId=${orderId}`);
    },
    GetRanusShippingLabel: async (orderId, companyId) => {
        return await BaseServices.Get(`/api/Orders/get-ranus-shipping-label?orderId=${orderId}&shippingCompanyId=${companyId}`);
    },
    GetNextOrderStatus: async (status) => {
        return await BaseServices.Get(`/api/Orders/get-next-order-status/${status}`);
    },
    MomoRefund: async (orderId) => {
        return await BaseServices.Get(`/api/Orders/momo-refund/${orderId}`);
    },
    CreateOrder: async (models) => {
        return await BaseEcomServices.Post("/api/Orders/create-order", models);
    },
    GetOrderReadyConfirmByOrderNumber: async (orderNumber) => {
        return await BaseEcomServices.Get(`/api/Orders/get-order-ready-confirm-by-order-number/${orderNumber}`);
    },
    GetOrderReadyConfirmByReadyListId: async (readyListId) => {
        return await BaseEcomServices.Get(`/api/Orders/get-order-ready-confirm-by-ready-list-id/${readyListId}`);
    },
    GetListProductModel: async (pageModel) => {
        return await BaseServices.Post("/api/Orders/get-list-product-model", pageModel);
    },
    UpdateTranscriptStatus: async (model) => {
        return await BaseServices.Post(`/api/Orders/update-transcript-status`, model);
    },
};
export default OrderServices;
